module.exports = __webpack_public_path__ + "static/img/smartProduct1.f0a5cd94.png";